import Vue from 'vue';
import App from './App.vue';
import store from './store/store';
import './assets/app.scss';
import VTooltip from 'v-tooltip'

Vue.use(VTooltip, {
  defaultTrigger: window.innerWidth > 768 ? 'hover focus click' : 'click'
})

Vue.filter('moneySaleFormat', (price) => {
  if (price) {
    return `$${price}`;
  }
  return '';
});

Vue.filter('getProductDesc', product => {
  return product.body_html.replace(/<script>[\s\S]*<\/script>/g,'').replace( /(<([^>]+)>)/ig, '');
});

Vue.filter('intToDecimalPrice', int => '$' + (int / 100).toFixed(2));

Vue.filter('getProductVariantImage', function (product,variantId){
  var productVariantImage = product.images.find(x => x.variant_ids.includes(variantId));
  if(productVariantImage){
    return productVariantImage.src;
  }
  return (product.images.length > 0) ? product.images[0].src : '';
});

Vue.filter('getProductImage', product => (product.images.length > 0) ? product.images[0].src : '');


/* eslint-disable no-unused-vars */
const RedeemApp = new Vue({
  el: '#Redeem',
  data: {
  },
  store,
  created() {
  },
  render: h => h(App),
});
